export class CacheService {
  private getStorageFn: () => Storage;

  constructor(storage: Storage | (() => Storage)) {
    if (typeof storage === 'function') {
      this.getStorageFn = storage as () => Storage;
    } else {
      this.getStorageFn = () => storage;
    }
  }

  private get storage(): Storage {
    return this.getStorageFn();
  }

  getItem<T>(key: string): T | null {
    const item = this.storage.getItem(key);
    if (item) {
      return JSON.parse(item) as T;
    }
    return null;
  }

  setItem<T>(key: string, value: T): void {
    this.storage.setItem(key, JSON.stringify(value));
  }

  removeItem(key: string): void {
    this.storage.removeItem(key);
  }

  clear(): void {
    this.storage.clear();
  }
}

export const sessionCache = new CacheService(() => sessionStorage);
export const localCache = new CacheService(() => localStorage);
